import React from 'react'
import SiteHeaderLoginStatus from './SiteHeaderLoginStatus'
import imageLogo from '../images/vera-green.svg'


export default function SiteHeader({global, dispatch}) {


  return (
    <div
      className='bp4-dark'
      style={{
        position: 'fixed',
        top: '0px',
        left: '0px',
        right: '0px',
        height: '3rem',
        overflow: 'hidden',
        backgroundColor: '#3178C6',
        padding: '6px',
        fontSize: '1rem',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        animation: 'headerglow 10s infinite ease-in',
        zIndex: '3',
      }}
    >

      <img className='logo' src={imageLogo} alt='VERA' />

      <div style={{flex: '1 1 auto', margin: '0em 1em', paddingTop: '2px'}}>
				System Dashboard
      </div>

      <div style={{flex: '0 0 auto', margin: '0em 0em 0em 1em'}}>
        <SiteHeaderLoginStatus global={global} dispatch={dispatch} />
      </div>

    </div>
  )
}
